import Select, { GroupBase, Props as SelectProps } from 'react-select';
import Async, { AsyncProps } from 'react-select/async';
import AsyncCreatable, {
  AsyncCreatableProps
} from 'react-select/async-creatable';
import Creatable, { CreatableProps } from 'react-select/creatable';

import { DropdownBaseProps, Render } from './dropdown-shared';

// Expose all the ReactSelect types
import type * as ReactSelect from 'react-select';
export { ReactSelect };

export type DropdownProps<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = SelectProps<Option, IsMulti, Group> & DropdownBaseProps;

export const Dropdown = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: DropdownProps<Option, IsMulti, Group>
) => Render(Select, props);

export type DropdownCreatableProps<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = CreatableProps<Option, IsMulti, Group> & DropdownBaseProps;

export const DropdownCreatable = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: DropdownCreatableProps<Option, IsMulti, Group>
) => Render(Creatable, props);

export type DropdownAsyncProps<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = AsyncProps<Option, IsMulti, Group> & DropdownBaseProps;

export const DropdownAsync = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: DropdownAsyncProps<Option, IsMulti, Group>
) => Render(Async, props);

export type DropdownAsyncCreatableProps<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = AsyncCreatableProps<Option, IsMulti, Group> & DropdownBaseProps;

export const DropdownAsyncCreatable = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: DropdownAsyncCreatableProps<Option, IsMulti, Group>
) => Render(AsyncCreatable, props);
